
const RESIZE = {
  title: 'How to resize image without losing quality',
  list: [
    {
      index: 1,
      title: "Upload an image",
      description: "Upload files that you want to resize automatically",
    },
    {
      index: 2,
      title: "Choose the width and height",
      description: "Select new image dimensions (aspect ratio), file size.",
    },
    {
      index: 3,
      title: "Resize an image",
      description: "Download the resized image with a new resolution in original quality. ",
    }
  ]
};

const ROTATE = {
  title: 'How to rotate image?',
  list: [
    {
      index: 1,
      title: ``,
      description: `To rotate an image, first of all, click the 
                    "Upload" button and select the image that you want to rotate.`,
    },
    {
      index: 2,
      title: ``,
      description: `You can upload a photo in any image format: JPG, PNG, BMP, [GIF].`,
    },
    {
      index: 3,
      title: ``,
      description: `Choose whether you want to rotate the image 90 or 180 degrees and click the "OK" button. 
                    Save rotated image.`,
    }
  ]
};

const FLIP = {
  title: 'How to flip image?',
  list: [
    {
      index: 1,
      title: ``,
      description: `Click the "Upload" button or drag-n-drop select the pic that you want to flip.`,
    },
    {
      index: 2,
      title: ``,
      description: `You can mirror photos in any format: JPG,  PNG, BMP, [GIF].`,
    },
    {
      index: 3,
      title: ``,
      description: `Choose whether you want to flip image vertically or horizontally and click "OK". 
                    Save flipped image.`,
    }
  ]
};


const CROPPER = {
  title: 'How to crop image?',
  list: [
    {
      index: 1,
      title: ``,
      description: `It's incredibly easy to crop images with our free tool.`,
    },
    {
      index: 2,
      title: ``,
      description: `Upload a photo in any format: JPG, BMP, [GIF], PNG images.`,
    },
    {
      index: 3,
      title: ``,
      description: `When the photo appears on a canvas, crop the image by dragging 
        the crop area or by setting the desired size.`,
    },
    {
      index: 4,
      title: ``,
      description: `Click "OK" when you are done cropping the photo. Don't forget to download the cropped image. 
        Crop more photos in the same way.`,
    }
  ]
};


export default function getContantPage(service: string) {
  switch (service) {
    case 'rotator':
      return ROTATE;
    case 'resizer':
      return RESIZE;
    case 'flipper':
      return FLIP;
    case 'cropper':
      return CROPPER;
    default:
      return {
        title: '',
        list: []
      };
  }

}
